var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col h-screen gap-4 p-5 justify-center items-center w-screen"},[_c('img',{staticClass:"w-96",attrs:{"src":require("@/assets/logo.png"),"alt":"logo"}})])
}]

export { render, staticRenderFns }